module.exports = __webpack_public_path__ + "assets/img/2809.05686317.png";